var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTz(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TZ",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#33CC4D",
    mask: "url(#mask-2)",
    points: "0 13.3333333 28 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#2DAFE4",
    mask: "url(#mask-2)",
    points: "0 20 28 20 28 6.66666667"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#FFD84F",
    mask: "url(#mask-2)",
    points: "3.08238507 22.6666972 30.1707194 5.74002727 24.9176149 -2.66669718 -2.17071939 14.2599727"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#262626",
    mask: "url(#mask-2)",
    points: "-0.629198978 23.0719328 32.1619941 2.58172121 28.629199 -3.07193276 -4.16199407 17.4182788"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/TZ.b425a5a7d32fdf8ef99208db4755134b.svg";
export { ForwardRef as ReactComponent };